import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import EventContacts from 'components/events/EventContacts';
import EventTitle from 'components/events/Timeline/EventTitle';
import PageContentHeader from 'components/common/PageContentHeader';
import AddPeopleButton from 'components/events/buttons/AddPeopleButton';

import { openErrorNotification } from 'graphql/hooks/common';

import { GET_EVENT } from 'graphql/queries/events';

import useStyles from './style';

const EventUsers: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { id: eventId } = useParams<keyof EventPageRouteParams>();

  const navigate = useNavigate();

  const { data: eventData } = useQuery<EventResponse>(GET_EVENT, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
    onError: e => {
      // @ts-ignore
      if (e.graphQLErrors.some(error => error.code === 'EVENT_NOT_FOUND')) {
        openErrorNotification(t('eventNotFoundMessage'));
        navigate('/not-found');
      }
    },
  });

  const event = eventData?.event as EventItem;

  return (
    <div className={classes.eventUsers}>
      {!!event ? (
        <PageContentHeader extra={!!event ? <AddPeopleButton /> : null}>
          <EventTitle name={event.title} />
        </PageContentHeader>
      ) : null}
      <EventContacts key="eventContacts" />
    </div>
  );
};

export default EventUsers;
